/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import MaterialProperty from './MaterialProperty';

/**
 * The NftGeneratorControllerDtoNftImageRecoveryResponse model module.
 * @module model/NftGeneratorControllerDtoNftImageRecoveryResponse
 * @version 1.0
 */
class NftGeneratorControllerDtoNftImageRecoveryResponse {
    /**
     * Constructs a new <code>NftGeneratorControllerDtoNftImageRecoveryResponse</code>.
     * @alias module:model/NftGeneratorControllerDtoNftImageRecoveryResponse
     */
    constructor() { 
        
        NftGeneratorControllerDtoNftImageRecoveryResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>NftGeneratorControllerDtoNftImageRecoveryResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/NftGeneratorControllerDtoNftImageRecoveryResponse} obj Optional instance to populate.
     * @return {module:model/NftGeneratorControllerDtoNftImageRecoveryResponse} The populated <code>NftGeneratorControllerDtoNftImageRecoveryResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new NftGeneratorControllerDtoNftImageRecoveryResponse();

            if (data.hasOwnProperty('resultCode')) {
                obj['resultCode'] = ApiClient.convertToType(data['resultCode'], 'Number');
            }
            if (data.hasOwnProperty('code')) {
                obj['code'] = ApiClient.convertToType(data['code'], 'String');
            }
            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
            if (data.hasOwnProperty('errorCode')) {
                obj['errorCode'] = ApiClient.convertToType(data['errorCode'], 'Number');
            }
            if (data.hasOwnProperty('contentsReward')) {
                obj['contentsReward'] = ApiClient.convertToType(data['contentsReward'], [MaterialProperty]);
            }
            if (data.hasOwnProperty('successCount')) {
                obj['successCount'] = ApiClient.convertToType(data['successCount'], 'Number');
            }
            if (data.hasOwnProperty('recoveredNftUidList')) {
                obj['recoveredNftUidList'] = ApiClient.convertToType(data['recoveredNftUidList'], ['Number']);
            }
            if (data.hasOwnProperty('healthyNftUidList')) {
                obj['healthyNftUidList'] = ApiClient.convertToType(data['healthyNftUidList'], ['Number']);
            }
            if (data.hasOwnProperty('failNftUidList')) {
                obj['failNftUidList'] = ApiClient.convertToType(data['failNftUidList'], ['Number']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>NftGeneratorControllerDtoNftImageRecoveryResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>NftGeneratorControllerDtoNftImageRecoveryResponse</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['code'] && !(typeof data['code'] === 'string' || data['code'] instanceof String)) {
            throw new Error("Expected the field `code` to be a primitive type in the JSON string but got " + data['code']);
        }
        // ensure the json data is a string
        if (data['description'] && !(typeof data['description'] === 'string' || data['description'] instanceof String)) {
            throw new Error("Expected the field `description` to be a primitive type in the JSON string but got " + data['description']);
        }
        if (data['contentsReward']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['contentsReward'])) {
                throw new Error("Expected the field `contentsReward` to be an array in the JSON data but got " + data['contentsReward']);
            }
            // validate the optional field `contentsReward` (array)
            for (const item of data['contentsReward']) {
                MaterialProperty.validateJSON(item);
            };
        }
        // ensure the json data is an array
        if (!Array.isArray(data['recoveredNftUidList'])) {
            throw new Error("Expected the field `recoveredNftUidList` to be an array in the JSON data but got " + data['recoveredNftUidList']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['healthyNftUidList'])) {
            throw new Error("Expected the field `healthyNftUidList` to be an array in the JSON data but got " + data['healthyNftUidList']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['failNftUidList'])) {
            throw new Error("Expected the field `failNftUidList` to be an array in the JSON data but got " + data['failNftUidList']);
        }

        return true;
    }


}



/**
 * @member {Number} resultCode
 */
NftGeneratorControllerDtoNftImageRecoveryResponse.prototype['resultCode'] = undefined;

/**
 * @member {String} code
 */
NftGeneratorControllerDtoNftImageRecoveryResponse.prototype['code'] = undefined;

/**
 * @member {String} description
 */
NftGeneratorControllerDtoNftImageRecoveryResponse.prototype['description'] = undefined;

/**
 * @member {Number} errorCode
 */
NftGeneratorControllerDtoNftImageRecoveryResponse.prototype['errorCode'] = undefined;

/**
 * @member {Array.<module:model/MaterialProperty>} contentsReward
 */
NftGeneratorControllerDtoNftImageRecoveryResponse.prototype['contentsReward'] = undefined;

/**
 * @member {Number} successCount
 */
NftGeneratorControllerDtoNftImageRecoveryResponse.prototype['successCount'] = undefined;

/**
 * @member {Array.<Number>} recoveredNftUidList
 */
NftGeneratorControllerDtoNftImageRecoveryResponse.prototype['recoveredNftUidList'] = undefined;

/**
 * @member {Array.<Number>} healthyNftUidList
 */
NftGeneratorControllerDtoNftImageRecoveryResponse.prototype['healthyNftUidList'] = undefined;

/**
 * @member {Array.<Number>} failNftUidList
 */
NftGeneratorControllerDtoNftImageRecoveryResponse.prototype['failNftUidList'] = undefined;






export default NftGeneratorControllerDtoNftImageRecoveryResponse;

